'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = existingAccounts;

var _immutable = require('immutable');

var _RequestState = require('../lib/RequestState');

var RequestState = _interopRequireWildcard(_RequestState);

var _ExistingAccountsActionTypes = require('../actionTypes/ExistingAccountsActionTypes');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = new _immutable.Map({
  accounts: null,
  fetchError: false,
  requestStatus: RequestState.NOT_REQUESTED
});

function existingAccounts() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case _ExistingAccountsActionTypes.ACCOUNTS_REQUESTED:
      return state.set('requestStatus', RequestState.REQUESTED);

    case _ExistingAccountsActionTypes.ACCOUNTS_FETCHED:
      return state.merge({
        accounts: payload,
        fetchError: false,
        requestStatus: RequestState.SUCCEEDED
      });

    case _ExistingAccountsActionTypes.ACCOUNTS_FETCHED_FAILED:
      return state.merge({
        accounts: null,
        fetchError: true,
        requestStatus: RequestState.FAILED
      });

    default:
      return state;
  }
}
module.exports = exports['default'];